


























































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class UrlPageVote extends Vue {
  @Prop() url!: string

  source: any = null

  onResult(data) {
    this.source = data.data.source
  }

  get vote() {
    return (this.source && this.source.myVote) || 0
  }

  voteDown() {
    this.$apollo.mutate({
      mutation: this.$gql(
        `mutation VOTE_ON_URL ($url:String!, $value:Int!) {
          voteOnUrl(url: $url, value: $value) {
            uid
          }
        }`),
      variables: {
        url: this.url,
        value: -1,
      },
    })
      .then(data => {
        this.onVoted(-1)
        this.source.myVote = -1

      })
      .catch((error) => {
        console.error(error)
      })
  }

  voteUp() {
    this.$apollo.mutate({
      mutation: this.$gql(
        `mutation VOTE_ON_URL ($url:String!, $value:Int!) {
          voteOnUrl(url: $url, value: $value) {
            uid
          }
        }`),
      variables: {
        url: this.url,
        value: 1,
      },
    })
      .then(data => {
        this.onVoted(1)
        this.source.myVote = 1
      })
      .catch((error) => {
        console.error(error)
      })
  }

  onVoted(val) {
    let myVote = this.source.myVote

    if (val === 1) {
      if (myVote === -1) {
        this.source.votesDownCount--
      }
      this.source.votesUpCount++
    } else if (val === -1) {
      if (myVote === 1) {
        this.source.votesUpCount--
      }
      this.source.votesDownCount++
    }
  }

  removeVote() {
    let oldVote = this.source.myVote
    this.$apollo.mutate({
      mutation: this.$gql(
        `mutation REMOVE_VOTE_FROM_URL ($url:String!) {
          removeVoteFromUrl(url: $url) {
            uid
          }
        }`),
      variables: {
        url: this.url,
      },
    })
      .then(data => {
        this.source.myVote = null
        if (oldVote === 1) {
          this.source.votesUpCount--
        } else if (oldVote === -1) {
          this.source.votesDownCount--
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

